export const messages = {
  en: {
    purchaseApplyDetail: {
      applyInfo: 'Application Information',
      applyNo: 'Application No',
      applicant: 'Applicant',
      endUser: 'End User',
      contactPhone: 'Contact Phone',
      applyTime: 'Application Time',
      referencePrice: 'Reference Price',
      approvalStatus: 'Approval Status',
      description: 'Description',
      applyMaterials: 'Application Materials',
      material: 'Material',
      materialCode: 'Material Code',
      unitPrice: 'Unit Price',
      stock: 'Stock',
      applyQuantity: 'Apply Quantity',
      remark: 'Remark',
      workflowProcess: 'Workflow Process',
      serialNumber: 'Serial Number',
      processor: 'Processor',
      status: 'Status',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion',
      print: 'Print',
      back: 'Back'
    }
  },
  zh: {
    purchaseApplyDetail: {
      applyInfo: '申请信息',
      applyNo: '申请单号',
      applicant: '申请人',
      endUser: '使用人',
      contactPhone: '联系电话',
      applyTime: '申请时间',
      referencePrice: '参考价格',
      approvalStatus: '审批状态',
      description: '说明',
      applyMaterials: '申请物资',
      material: '物资',
      materialCode: '物资编码',
      unitPrice: '单价',
      stock: '库存',
      applyQuantity: '申请数量',
      remark: '备注',
      workflowProcess: '工单流转',
      serialNumber: '序号',
      processor: '处理人',
      status: '状态',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见',
      print: '打印',
      back: '返回'
    }
  }
}